import type { FileRoutesByTo } from '@/routeTree.gen';

export enum Routes {
  Accessibility = '/accessibility',
  Chats = '/chats',
  AllChats = '/chats/all',
  Feed = '/feed',
  AgentsAttention = '/agents/attention',
  AgentsNewTask = '/agents/new-task',
  SharedChat = '/shared-chat',
  Welcome = '/welcome',
  Journal = '/journal',
  Meetings = '/meetings',
  Routines = '/routines',
  Home = '/',
  Echonotes = '/echonotes',
  Debug = '/debug',
  Onboarding = '/onboarding',
  Ingestion = '/ingestion',
  Arena = '/arena',
  CkDebug = '/ck-debug',
  MeetingDebug = '/meeting-debug',
  McpInfo = '/mcp-info',
  PeopleWiki = '/people-wiki',
  SummaryTimeline = '/summary-timeline',
  ActivityTimeline = '/activity-timeline',
  ChannelSimulator = '/channel-simulator',
  Sprites = '/sprites',
  Integrations = '/integrations',
  Projects = '/projects',
  Settings = '/settings',
  Upgrade = '/upgrade',
  BirdGame = '/bird-game',
}

export type RouteParams<T extends keyof FileRoutesByTo> =
  FileRoutesByTo[T]['types']['allParams'];

export type RouteSearch<T extends keyof FileRoutesByTo> =
  FileRoutesByTo[T]['types']['fullSearchSchemaInput'];
